export default {
  name: 'app-header',
  computed: {
    canManage () {
      return this.$store.getters.canManage
    },
    isLogin () {
      return this.$store.getters.isLogin
    },
    currentUserName () {
      return this.$store.getters.userName
    },
    currentShopName () {
      return this.$store.getters.currentShopName
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch('LOGOUT')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app-header.js